import type { SVGProps } from "react";

export default function SolarHammerLinear(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}>
                <path d="M5.686 18.314C8.276 20.904 12.09 21.38 15 19.742m-9.314-1.428L12 12m-6.314 6.314C3.096 15.724 2.62 11.91 4.258 9m0 0c.192-.338.41-.663.654-.973C7.026 5.41 11.437 4.866 14.5 6.5L17.5 3.5c.828-.828 2.172-.828 3 0s.828 2.172 0 3L17.5 9.5c1.634 3.063 1.09 7.474-1.527 9.588c-.31.244-.635.462-.973.654m-10.742-10.742L12 12m3 7.742L12 12" />
            </g>
        </svg>
    );
}
